import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgNavMenuCollaspsed({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path d="M10.38 2H1.4a.4.4 0 00-.4.41v1.24c0 .23.18.4.4.4h8.98a.4.4 0 00.4-.4V2.4a.4.4 0 00-.4-.41M1.4 9.14h7.79a.4.4 0 00.4-.41V7.49a.4.4 0 00-.4-.41h-7.8a.4.4 0 00-.39.41v1.24c0 .22.18.4.4.4m8.98 3.03H1.4a.4.4 0 00-.4.41v1.24c0 .22.18.4.4.4h8.98a.4.4 0 00.4-.4v-1.24a.4.4 0 00-.4-.41m4.09-6.96l-3.3 2.65c-.18.14-.17.4 0 .55l3.3 2.64c.18.16.53.07.53-.39V5.6c0-.55-.35-.55-.53-.39" />
    </svg>
  );
}

SvgNavMenuCollaspsed.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgNavMenuCollaspsed.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgNavMenuCollaspsed svgRef={ref} {...props} />
));
export default ForwardRef;
